import i18n from '@/libs/i18n'
import type { ErrorEnvelope } from '@/types/Common'

// Error codes per api-contract §6.
export enum Errors {
    InternalServerError = 1,
    InvalidData         = 2,
    ItemNotFound        = 3,
    Unauthorized        = 4,
    FailedToInsert      = 5,
    Forbidden           = 6,
    SlotOccupied        = 7,
    QuotaExceeded       = 8,
    EmailInUse          = 9,
    HasReservations     = 10,
    AlreadyResolved     = 11,
    WrongOldPassword    = 12,
    InUse               = 13,
}

const messageKey: Record<number, string> = {
    [Errors.InternalServerError]: 'errors.internal',
    [Errors.InvalidData]:         'errors.invalid_data',
    [Errors.ItemNotFound]:        'errors.not_found',
    [Errors.Unauthorized]:        'errors.unauthorized',
    [Errors.FailedToInsert]:      'errors.failed_to_insert',
    [Errors.Forbidden]:           'errors.forbidden',
    [Errors.SlotOccupied]:        'errors.slot_occupied',
    [Errors.QuotaExceeded]:       'errors.quota_exceeded',
    [Errors.EmailInUse]:          'errors.email_in_use',
    [Errors.HasReservations]:     'errors.has_reservations',
    [Errors.AlreadyResolved]:     'errors.already_resolved',
    [Errors.WrongOldPassword]:    'errors.wrong_old_password',
    [Errors.InUse]:               'errors.in_use',
}

export const parseError = (errorObject: unknown, fallback = ''): string => {
    const t = i18n.global.t
    const code = (errorObject as ErrorEnvelope | null)?.error?.code
    if (!code) return fallback || t('errors.generic_error')
    const key = messageKey[code]
    if (!key) return fallback || t('errors.generic_error')
    return t(key)
}
